export default __webpack_public_path__ + "static/media/tracksmith.27668133.png";